import { Plugin, PluginKey } from "prosemirror-state";
import { createNodeFromUploadedFile } from "../commands";
export const filestackPickerPluginKey = new PluginKey("filestackPickerPluginKey");
export const filestackPickerPlugin = (service) => {
    let view = null;
    return new Plugin({
        key: filestackPickerPluginKey,
        view: (_view) => {
            view = _view;
            return { update: () => null, destroy: () => null };
        },
        state: {
            init: () => null,
            apply: (tr) => {
                const meta = tr.getMeta(filestackPickerPluginKey);
                if (meta) {
                    const { mode } = meta;
                    const { to } = tr.selection;
                    service
                        .openPicker(mode)
                        .then((files) => {
                        const nodes = files.map((file) => createNodeFromUploadedFile(view, file, mode));
                        view.dispatch(view.state.tr.insert(to, nodes).scrollIntoView());
                        view.focus();
                    })
                        .catch((err) => {
                        console.error(err);
                    });
                }
            },
        },
    });
};
